import { Button, Form } from 'react-bootstrap'
import { useState } from 'react'
import "./Register.css"
import LoadingIndicator from '../Indicators/LoadingIndicator'
import ErrorWindow from '../Indicators/ErrorWindow'
import { REGISTER_URL } from '../Api'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import TermsOfService from './TermsOfService'
import { DEBUG, CAPTCHA_SITE_KEY, APP_DIRECTORY } from '../SystemVariables'
import ReCAPTCHA from "react-google-recaptcha";
import VerifyEmail from './VerifyEmail'

const hasValue = (d) => {
    if(d === undefined) return false
    else if(d.trim() === "") return false
    else return true
}

const passwordIsValid = (password) => {
    return hasValue(password)
}

const emailIsValid = (email) => {
    const words = email.split("@")
    if(words.length === 2) {
        const domain = words[1]
        const domainParts = domain.split(".")
        for(let i in domainParts) {
            const p = domainParts[i]
            if(p.length <= 0) return false
        }
        return (domainParts.length >= 2)
    } else {
        return false
    }
}

const verify = (username, password, agreeToTerms, captcha, email) => {
    return hasValue(username) && passwordIsValid(password) && agreeToTerms && (captcha || DEBUG) && emailIsValid(email)
}

const getCaptchaField = (onValueChange) => {
    if(!DEBUG) {
        return (<ReCAPTCHA sitekey={CAPTCHA_SITE_KEY} onChange={onValueChange}/>)
    } else {
        return []
    }
}

const Register = (props) => {
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [email, setEmail] = useState("")
    const [redirectCountdown, setRedirectCountdown] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const [error, setError] = useState(undefined)
    const [showTermsOfService, setShowTermsOfService] = useState(false)
    const [agreeToTerms, setAgreeToTerms] = useState(false)
    const [captcha, setCaptcha] = useState(undefined)

    const onUsernameChanged = (event) => {
        setUsername(event.target.value)
    }

    const onPasswordChanged = (event) => {
        setPassword(event.target.value)
    }

    const onEmailChanged = event => {
        setEmail(event.target.value)
    }

    const submit = (event) => {
        event.preventDefault()
        setSubmitting(true)
        const formData = new FormData()
        const usernameTrimmed = username.trim()
        const passwordTrimmed = password.trim()
        const emailTrimmed = email.trim()
        formData.append("username", usernameTrimmed)
        formData.append("password", passwordTrimmed)
        formData.append("email", emailTrimmed)
        formData.append("agreeToServiceTerms", agreeToTerms)
        formData.append("captcha", captcha)
        fetch(REGISTER_URL, {
            method: 'post',
            body: formData
        })
        .then(response=>{
            if (response.ok) {
                setSubmitting(false)
                setRedirectCountdown(true)
            } else {
                const error = new Error(`Network response was not ok: ${response.status}`)
                error.response = response
                throw error
            }
        })
        .catch((err)=>{
            if(err.response !== undefined && (err.response.status === 409 || err.response.status === 406)) {
                err.response.json()
                .then((json)=>{
                    setSubmitting(false)
                    setError(json.status)
                })
            } else {
                setSubmitting(false)
                setError("Something went wrong. Please check your internet connection and try again!")
            }
        })
    }

    if(submitting) {
        return(<LoadingIndicator message={`Registering user "${username}"...`}/>)
    } else if(error) {
        return(<ErrorWindow message={error} continue={()=>{setError(undefined)}}/>)
    } else if(redirectCountdown) {
        return(<VerifyEmail email={email}/>)
    } else if(showTermsOfService) {
        const onAgree = () => {
            setAgreeToTerms(true)
            setShowTermsOfService(false)
        }
        return(<TermsOfService onAgree={onAgree} onCancel={()=>{setShowTermsOfService(false)}}/>)
    } else {
        const onChangedCheckbox = () => {
            setAgreeToTerms(!agreeToTerms)
        }

        const onChangeCaptcha = value => {
            setCaptcha(value)
        }

        const captchaField = getCaptchaField(onChangeCaptcha)

        return(
        <div className="register">
            <h1>Register</h1>
            <Form onSubmit={submit}>
                <Form.Group controlId="username" className="mb-3">
                    <Form.Label>Username</Form.Label>
                    <Form.Control type="text" onChange={onUsernameChanged} value={username}/>
                </Form.Group>
                <Form.Group controlId="email" className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="text" onChange={onEmailChanged} value={email}/>
                </Form.Group>
                <Form.Group controlId="password" className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" onChange={onPasswordChanged} value={password}/>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" label={<div>I agree to the <Link onClick={()=>{setShowTermsOfService(true)}}>Terms of Service</Link></div>} checked={agreeToTerms} onChange={onChangedCheckbox}/>
                </Form.Group>
                {captchaField}
                <p/>
                <div className="formButtons">
                    <Link to={`${APP_DIRECTORY}/login`}><div className="btn btn-danger">Cancel</div></Link>
                    <Button disabled={!verify(username, password, agreeToTerms, captcha, email)} type="submit">Register</Button>
                </div>
            </Form>
        </div>)
    }
}

export default Register
